(function(){
  if (window.__brfSmoke) return; window.__brfSmoke = true;
  if (!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var NOSE = [[.552, .538], [.622, .538]];      /* left and right nostril, as fractions of the bull crop */
  var CW = 440, CH = 320, AX = 190, AY = 170;  /* canvas size and where the nose sits inside it */
  var cv, ctx, dpr = Math.min(2, window.devicePixelRatio || 1), parts = [], link = null, on = false, raf = 0, last = 0, nextSnort = 0, sprite, spriteTint;
  function makeSprite(r, g, b){
    var c = document.createElement('canvas'); c.width = c.height = 128; var x = c.getContext('2d');
    var gr = x.createRadialGradient(64, 64, 0, 64, 64, 64);
    gr.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',.62)'); gr.addColorStop(.35, 'rgba(' + r + ',' + g + ',' + b + ',.36)');
    gr.addColorStop(.7, 'rgba(' + r + ',' + g + ',' + b + ',.1)'); gr.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
    x.fillStyle = gr; x.fillRect(0, 0, 128, 128);
    /* wispy texture so it reads as smoke, not a blur ball */
    x.globalCompositeOperation = 'destination-out';
    for (var i = 0; i < 26; i++) { var a = Math.random() * 6.28, d = 18 + Math.random() * 40; x.beginPath(); x.arc(64 + Math.cos(a) * d, 64 + Math.sin(a) * d, 4 + Math.random() * 10, 0, 6.28); x.fillStyle = 'rgba(0,0,0,' + (.15 + Math.random() * .25) + ')'; x.fill(); }
    return c;
  }
  function setup(){
    cv = document.createElement('canvas'); cv.className = 'brf-smoke'; cv.setAttribute('aria-hidden', 'true');
    cv.width = CW * dpr; cv.height = CH * dpr; document.body.appendChild(cv);
    ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    sprite = makeSprite(105, 107, 114);
    spriteTint = [makeSprite(150, 210, 180), makeSprite(225, 205, 150), makeSprite(190, 170, 230)];
  }
  function nose(){
    var img = link && link.querySelector('.header__logo-image'); if (!img) return null;
    var r = img.getBoundingClientRect(), cs = getComputedStyle(link), f = function(k, d){ var v = parseFloat(cs.getPropertyValue(k)); return isNaN(v) ? d : v; };
    var x1 = f('--x1', .13), x2 = f('--x2', .87), y1 = f('--y1', .11), y2 = f('--y2', .63), s = r.width;
    var L = r.left + x1 * s, T = r.top + y1 * s, W = (x2 - x1) * s, H = (y2 - y1) * s;
    return {pts: NOSE.map(function(n){ return [L + n[0] * W, T + n[1] * H]; }), scale: H / 60};
  }
  function puff(n, side, k){
    var p = n.pts[side], dir = side ? 1 : -1, sc = Math.max(.6, Math.min(1.4, n.scale));
    for (var i = 0; i < k; i++) {
      var tinted = Math.random() < .28;
      parts.push({
        x: p[0], y: p[1], vx: dir * (side ? .75 : 1) * (55 + Math.random() * 60) * sc, vy: (30 + Math.random() * 45) * sc,
        r: (2 + Math.random() * 3) * sc, gr: (16 + Math.random() * 16) * sc, life: 0, max: 1.6 + Math.random() * 1.4,
        rot: Math.random() * 6.28, vr: (Math.random() - .5) * 1.4, seed: Math.random() * 100,
        img: tinted ? spriteTint[(Math.random() * 3) | 0] : sprite, a: tinted ? .85 : 1
      });
    }
    if (Math.random() < .9) for (var j = 0; j < 3; j++) parts.push({spark: true, x: p[0] + (Math.random() - .5) * 6, y: p[1], vx: dir * (10 + Math.random() * 30), vy: (-10 - Math.random() * 30), life: 0, max: .8 + Math.random() * .8, seed: Math.random() * 100});
  }
  function snort(n){
    puff(n, 0, 7); puff(n, 1, 7);
    link.classList.add('brf-snort'); setTimeout(function(){ link && link.classList.remove('brf-snort'); }, 160);
  }
  function frame(t){
    raf = 0; var dt = Math.min(.05, (t - (last || t)) / 1000); last = t;
    var n = link && nose();
    if (n) { cv.style.transform = 'translate(' + (n.pts[0][0] - AX) + 'px,' + (n.pts[0][1] - AY) + 'px)'; }
    if (on && n && t >= nextSnort) { snort(n); setTimeout(function(){ if (on) { var m = nose(); if (m) { puff(m, 0, 4); puff(m, 1, 4); } } }, 170); nextSnort = t + 1250 + Math.random() * 500; }
    var ox = n ? n.pts[0][0] - AX : 0, oy = n ? n.pts[0][1] - AY : 0;
    ctx.clearRect(0, 0, CW, CH);
    for (var i = parts.length - 1; i >= 0; i--) {
      var q = parts[i]; q.life += dt; var k = q.life / q.max;
      if (k >= 1) { parts.splice(i, 1); continue; }
      /* exhaled down and out, then slowed by the air and lifted as it warms; a little swirl so it curls */
      var swirl = Math.sin(q.seed + q.life * 3.1) * 14 + Math.sin(q.seed * 2 + q.life * 5.3) * 6;
      q.vx *= Math.pow(.3, dt); q.vy = q.vy * Math.pow(.08, dt) - 38 * dt;
      q.x += (q.vx + (q.spark ? 0 : swirl * .9)) * dt; q.y += q.vy * dt;
      var x = q.x - ox, y = q.y - oy;
      if (q.spark) {
        var tw = .5 + .5 * Math.sin(q.seed + q.life * 22), al = (1 - k) * tw;
        ctx.globalAlpha = al; ctx.fillStyle = '#F5D77A';
        ctx.beginPath(); ctx.moveTo(x, y - 3); ctx.lineTo(x + .9, y - .9); ctx.lineTo(x + 3, y); ctx.lineTo(x + .9, y + .9); ctx.lineTo(x, y + 3); ctx.lineTo(x - .9, y + .9); ctx.lineTo(x - 3, y); ctx.lineTo(x - .9, y - .9); ctx.closePath(); ctx.fill();
        continue;
      }
      q.rot += q.vr * dt; q.r += q.gr * dt * (1 - k * .6);
      var fade = k < .12 ? k / .12 : Math.pow(1 - (k - .12) / .88, 1.6);
      ctx.globalAlpha = q.a * fade; var d = q.r * 2;
      ctx.save(); ctx.translate(x, y); ctx.rotate(q.rot); ctx.drawImage(q.img, -q.r, -q.r, d, d); ctx.restore();
    }
    ctx.globalAlpha = 1;
    if (on || parts.length) raf = requestAnimationFrame(frame); else cv.classList.remove('is-on');
  }
  function start(a){
    if (!cv) setup();
    if (document.documentElement.classList.contains('brf-hc')) return; /* the slim capsule bar keeps the home button */
    link = a; on = true; nextSnort = 0; cv.classList.add('is-on');
    if (!raf) { last = 0; raf = requestAnimationFrame(frame); }
  }
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest && e.target.closest('#shopify-section-header .header__logo-link');
    if (a && !on) start(a);
  });
  document.addEventListener('mouseout', function(e){
    if (!on || !link) return;
    var to = e.relatedTarget; if (to && link.contains(to)) return;
    if (e.target === link || link.contains(e.target)) on = false;
  });
})();
